import { getEnvParam } from "@/env";

interface DistributionBucket {
    min: number;
    max: number;
    count: number;
    /** Total UPRNs (addresses) across the cells in this bin. 0 for places —
     * only meaningful for the cell/token-level distribution. */
    uprn_count: number;
}

export interface AttributeDistribution {
    distribution: DistributionBucket[];
    min: number;
    max: number;
    count: number;
    uprn_count: number;
}

export async function getCellAttributeDistribution(
    attributeName: string,
    level: number,
): Promise<AttributeDistribution> {
    const result = await fetch(
        `${process.env.BUN_PUBLIC_TILE_SERVER}/api/attributes/${encodeURIComponent(attributeName)}/distribution/${level}?${getEnvParam()}`,
        {
            headers: {
                "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
            },
        },
    );

    return result.json();
}

export async function getPlaceAttributeDistribution(
    level: number,
    attributeName: string,
): Promise<AttributeDistribution> {
    const result = await fetch(
        `${process.env.BUN_PUBLIC_TILE_SERVER}/api/places/${level}/${encodeURIComponent(attributeName)}/distribution?${getEnvParam()}`,
        {
            headers: {
                "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
            },
        },
    );

    return result.json();
}
